(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const initialised = new WeakSet();
  const roots = new WeakSet();
  const scan = root => {
    if (!mobile.matches) return;
    const toolbar = root.closest?.('#ft-floating-toolbar') || root.querySelector('#ft-floating-toolbar');
    if (toolbar && !initialised.has(toolbar)) {
      const toggle = toolbar.querySelector('button[aria-label="Toggle privacy and legal settings display"]');
      const bubble = toolbar.querySelector('#ft-reg-bubble');
      if (toggle && bubble && !bubble.classList.contains('ft-collapsed')) {
        initialised.add(toolbar);
        requestAnimationFrame(() => requestAnimationFrame(() => toggle.click()));
      }
    }
    if (root.shadowRoot) observe(root.shadowRoot);
    for (const element of root.querySelectorAll('*')) {
      if (element.shadowRoot) observe(element.shadowRoot);
    }
  };
  const observe = root => {
    if (roots.has(root)) return;
    roots.add(root);
    new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType === 1) scan(node);
        }
      }
    }).observe(root, { childList: true, subtree: true });
    scan(root);
  };
  observe(document);
  mobile.addEventListener('change', event => {
    if (event.matches) {
      const walk = root => {
        scan(root);
        for (const element of root.querySelectorAll('*')) {
          if (element.shadowRoot) walk(element.shadowRoot);
        }
      };
      walk(document);
    }
  });
})();